import React from 'react';
export var CoherencePersonaText = function (props) {
    var isTitle = props.isTitle, text = props.text, classNames = props.classNames;
    return isTitle ? React.createElement("h2", { className: classNames.title }, text) : React.createElement("div", { className: classNames.subtitle }, text);
};
//# sourceMappingURL=CoherencePersonaText.js.map